import { LayoutStandardPage } from "../layout/LayoutStandardPage"
import { PartialAboutMePage } from "../layout/Partial/PartialAboutMePage";

export const AboutMePage = () => {

    return(
        <LayoutStandardPage component={PartialAboutMePage.toString()} />
    )
}